module.exports = __webpack_public_path__ + "3795cbe6142d26669cd0d8e6312678a1.jpg";